import NotFound from './components/NotFound'
import BaseViewFrame from './components/BaseViewFrame'
import FurnitureLighting from '../modules/furniture_lighting/routes'
import FutureHouse from '../modules/future_house_awards/routes'
import Dashboard from '../modules/dashboard/routes'

export const routes = [
    {
        path: '/',
        component: BaseViewFrame,
        name: 'base-path',
        children: [
            {
                path: '/',
                component: NotFound,
                beforeEnter(to, from, next) {
                    window.location.href = "https://globaldesignnews.com";
                },
                name: 'index-redirect',
            },
            ...FurnitureLighting,
            ...FutureHouse,
            ...Dashboard,
            {
                path: '*',
                component: NotFound,
                name: 'not_found'
            }
        ]
    },
]

